import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export type I18nTranslate = typeof i18n.t;

export const createi18n = () => {
  // i18n
  i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
      lng: 'fr',
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false,
      },
    });

  return i18n;
};

// Export configured i18n instance
export default createi18n();
